// ======================================================================
// FILE: src/modules/wms/services/wmsTeamService.js
// MODULE: Work Management System (WMS)
// FEATURE: Team Management API Service
//
// PURPOSE:
//   Frontend API client for Team Management
//
// BACKEND:
//   /api/wms/teams
// ======================================================================

import axiosClient from "../../../api/axiosClient";

/**
 * ----------------------------------------------------------------------
 * LIST TEAMS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/teams
 */
async function listTeams(params = {}) {

  const res = await axiosClient.get(
    "/api/wms/teams",
    { params }
  );

  const payload = res.data?.data || {};

  return {
    items: payload.data || [],
    pagination: payload.pagination || {},
  };
}

/**
 * ----------------------------------------------------------------------
 * GET TEAM
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/teams/:id
 */
async function getTeam(teamId) {

  const res = await axiosClient.get(
    `/api/wms/teams/${teamId}`
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * CREATE TEAM
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/teams
 */
async function createTeam(payload) {

  const res = await axiosClient.post(
    "/api/wms/teams",
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * UPDATE TEAM
 * ----------------------------------------------------------------------
 * Backend:
 * PUT /api/wms/teams/:id
 */
async function updateTeam(
  teamId,
  payload
) {

  const res = await axiosClient.put(
    `/api/wms/teams/${teamId}`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * DELETE TEAM
 * ----------------------------------------------------------------------
 * Backend:
 * DELETE /api/wms/teams/:id
 */
async function deleteTeam(teamId) {

  const res = await axiosClient.delete(
    `/api/wms/teams/${teamId}`
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * GET TEAM MEMBERS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/teams/:id/members
 */
async function getMembers(teamId) {

  const res = await axiosClient.get(
    `/api/wms/teams/${teamId}/members`
  );

  return res.data.data || [];
}

/**
 * ----------------------------------------------------------------------
 * GET ALL TEAM MEMBERS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/teams/members
 */
async function getAllMembers() {

  const res = await axiosClient.get(
    "/api/wms/teams/members"
  );

  return res.data.data || [];
}
/**
 * ----------------------------------------------------------------------
 * GET AVAILABLE USERS
 * ----------------------------------------------------------------------
 * Backend:
 * GET /api/wms/teams/available-users
 */
async function getAvailableUsers() {

  const res = await axiosClient.get(
    "/api/wms/teams/available-users"
  );

  return res.data.data || [];
}


/**
 * ----------------------------------------------------------------------
 * UPDATE TEAM MEMBER
 * ----------------------------------------------------------------------
 * Backend:
 * PUT /api/wms/teams/:teamId/members/:memberId
 */
async function updateMember(
  teamId,
  memberId,
  payload
) {

  const res = await axiosClient.put(
    `/api/wms/teams/${teamId}/members/${memberId}`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * ADD TEAM MEMBER
 * ----------------------------------------------------------------------
 * Backend:
 * POST /api/wms/teams/:id/members
 */
async function addMember(
  teamId,
  payload
) {

  const res = await axiosClient.post(
    `/api/wms/teams/${teamId}/members`,
    payload
  );

  return res.data.data;
}

/**
 * ----------------------------------------------------------------------
 * REMOVE TEAM MEMBER
 * ----------------------------------------------------------------------
 * Backend:
 * DELETE /api/wms/teams/:teamId/members/:memberId
 */
async function removeMember(
  teamId,
  memberId
) {

  const res = await axiosClient.delete(
    `/api/wms/teams/${teamId}/members/${memberId}`
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */
const wmsTeamService = {

  listTeams,
  getTeam,

  createTeam,
  updateTeam,
  deleteTeam,

  getMembers,
  getAllMembers,
  getAvailableUsers,
  
  addMember,
  updateMember,
  removeMember,
};

export default wmsTeamService;